import React from 'react'
import {   Field} from 'redux-form'



const svinputRenderField = ({input, label, type, meta:{error, touched}})=>{
    return(

     
            <input {...input}  component="input" type="input"   className="form-control" />
           

    
       
    )

}
export class SVPNInputEp extends React.Component{
    

    constructor(props){
        super(props)


    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVString')

    }
   

    render(){
        console.log('render number  aka phonexxnumber')
        console.log(this.props)

        let me = this

       let {member,index, placeholder ='Port Z'} = this.props

          return (
              
            <Field
         
            name={`${member}.number`}
            type="text"
            component={svinputRenderField}
            placeholder={placeholder}

            className="form-control"
           
          />)
          
       

    }
}